import React, { useEffect, useState } from 'react';

import '../icons';

import '../styles/style.scss';
import { VISIBLE_FEATURES } from '../constants';
import Header from './Header';
import Footer from './Footer';
import CookieBar from './CookieBar';
import ReservedContentPopUp from './ReservedContentPopUp';

import * as styles from './Layout.module.scss';

interface LayoutProps {
  children: React.ReactNode;
  className?: string;
}

const Layout = ({ children, className }: LayoutProps): React.ReactElement => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isReservedContentPopUpVisible, setIsReservedContentPopUpVisible] = useState(false);

  useEffect(() => {
    if (
      VISIBLE_FEATURES.includes('reserved_content_pop_up') &&
      window.localStorage &&
      !window.localStorage.getItem('hasConfirmedReservedContentPopUp')
    ) {
      setIsReservedContentPopUpVisible(true);
    }
  }, []);

  return (
    <div className={styles.wrapper}>
      <Header
        isMenuOpen={isMenuOpen}
        onHamburguerMenuTouch={() => setIsMenuOpen(!isMenuOpen)}
      ></Header>
      <div
        id="main"
        className={styles.main + (className ? ' ' + className : '')}
        onClick={() => {
          setIsMenuOpen(false);
        }}
      >
        {children}
      </div>
      <Footer
        onClick={() => {
          setIsMenuOpen(false);
        }}
      ></Footer>
      <CookieBar></CookieBar>
      {isReservedContentPopUpVisible && (
        <div className={styles.overlay}>
          <div className={styles.popUpWrapper}>
            <ReservedContentPopUp
              onButtonClick={() => {
                setIsReservedContentPopUpVisible(false);
                window.localStorage.setItem('hasConfirmedReservedContentPopUp', 'true');
              }}
            ></ReservedContentPopUp>
          </div>
        </div>
      )}
    </div>
  );
};

export default Layout;
